import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { Form } from '../../../components';

import css from './KeywordSearchBar.module.css';

const SearchIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden="true" className={css.icon}>
    <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="2" />
    <path d="M13.5 13.5L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

/**
 * Keyword search bar for the worker jobs search page.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {string} [props.initialKeywords]
 * @param {Function} props.onSubmit
 * @returns {JSX.Element}
 */
const KeywordSearchBar = props => {
  const { className, initialKeywords = '', onSubmit } = props;
  const intl = useIntl();
  const placeholder = intl.formatMessage({ id: 'SearchPage.keywordPlaceholder' });

  return (
    <FinalForm
      key={initialKeywords}
      initialValues={{ keywords: initialKeywords }}
      onSubmit={values => onSubmit((values.keywords || '').trim())}
      render={({ handleSubmit }) => (
        <Form className={classNames(css.root, className)} onSubmit={handleSubmit}>
          <label className={css.label} htmlFor="search-page-keyword">
            <FormattedMessage id="SearchPage.keywordLabel" />
          </label>
          <div className={css.bar}>
            <Field
              name="keywords"
              render={({ input }) => (
                <input
                  {...input}
                  id="search-page-keyword"
                  className={css.input}
                  type="text"
                  placeholder={placeholder}
                  autoComplete="off"
                  aria-label={placeholder}
                />
              )}
            />
            <button
              type="submit"
              className={css.submit}
              aria-label={intl.formatMessage({ id: 'SearchPage.keywordSubmit' })}
            >
              <SearchIcon />
            </button>
          </div>
        </Form>
      )}
    />
  );
};

export default KeywordSearchBar;
